/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountControllerDtoWithdrawalLogListRequest model module.
 * @module model/AccountControllerDtoWithdrawalLogListRequest
 * @version 1.0
 */
class AccountControllerDtoWithdrawalLogListRequest {
    /**
     * Constructs a new <code>AccountControllerDtoWithdrawalLogListRequest</code>.
     * @alias module:model/AccountControllerDtoWithdrawalLogListRequest
     * @param page {Number} 
     * @param pageLength {Number} 
     */
    constructor(page, pageLength) { 
        
        AccountControllerDtoWithdrawalLogListRequest.initialize(this, page, pageLength);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, page, pageLength) { 
        obj['page'] = page;
        obj['pageLength'] = pageLength;
    }

    /**
     * Constructs a <code>AccountControllerDtoWithdrawalLogListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoWithdrawalLogListRequest} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoWithdrawalLogListRequest} The populated <code>AccountControllerDtoWithdrawalLogListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoWithdrawalLogListRequest();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('pageLength')) {
                obj['pageLength'] = ApiClient.convertToType(data['pageLength'], 'Number');
            }
            if (data.hasOwnProperty('skip')) {
                obj['skip'] = ApiClient.convertToType(data['skip'], 'Number');
            }
            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoWithdrawalLogListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoWithdrawalLogListRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AccountControllerDtoWithdrawalLogListRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

AccountControllerDtoWithdrawalLogListRequest.RequiredProperties = ["page", "pageLength"];

/**
 * @member {Number} page
 */
AccountControllerDtoWithdrawalLogListRequest.prototype['page'] = undefined;

/**
 * @member {Number} pageLength
 */
AccountControllerDtoWithdrawalLogListRequest.prototype['pageLength'] = undefined;

/**
 * @member {Number} skip
 */
AccountControllerDtoWithdrawalLogListRequest.prototype['skip'] = undefined;

/**
 * @member {Date} beginDate
 */
AccountControllerDtoWithdrawalLogListRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
AccountControllerDtoWithdrawalLogListRequest.prototype['endDate'] = undefined;

/**
 * @member {Number} accountNo
 */
AccountControllerDtoWithdrawalLogListRequest.prototype['accountNo'] = undefined;






export default AccountControllerDtoWithdrawalLogListRequest;

